import { useSyncExternalStore } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { SPACE_LABELS, useAppStore, type SpaceFilter } from "./store";
import { useAuth } from "./auth";
import { useLiveData } from "./useLiveData";
import { flushQueue, subscribeQueueCount } from "../offline/queue";

const SPACES: SpaceFilter[] = ["all", "praca", "prywatne"];

const NAV = [
  { to: "/chat", label: "Chat", icon: "💬" },
  { to: "/listy", label: "Listy", icon: "📋" },
  { to: "/przeglad", label: "Przegląd", icon: "🔄" },
  { to: "/ustawienia", label: "Ustawienia", icon: "⚙️" },
];

/** Liczba wrzutek czekających w kolejce offline (Faza 7). */
let queueSnapshot = 0;

function useQueuedCount(): number {
  return useSyncExternalStore(
    (onChange) =>
      subscribeQueueCount((count) => {
        queueSnapshot = count;
        onChange();
      }),
    () => queueSnapshot,
    () => 0,
  );
}

export function Layout() {
  const space = useAppStore((s) => s.space);
  const setSpace = useAppStore((s) => s.setSpace);
  const { logout } = useAuth();
  const queued = useQueuedCount();
  // Eventy `data.changed` odświeżają listy niezależnie od otwartego ekranu.
  useLiveData();

  return (
    <div className="shell">
      <header className="topbar">
        <div className="topbar__spaces" role="tablist" aria-label="Przestrzeń">
          {SPACES.map((s) => (
            <button
              key={s}
              role="tab"
              aria-selected={space === s}
              className={`chip ${space === s ? "chip--active" : ""}`}
              onClick={() => setSpace(s)}
            >
              {SPACE_LABELS[s]}
            </button>
          ))}
        </div>
        {queued > 0 && (
          <button
            className="chip chip--queued"
            title="Wrzutki czekają na sieć — kliknij, żeby spróbować teraz"
            onClick={() => void flushQueue()}
          >
            offline: {queued}
          </button>
        )}
        <button className="topbar__logout" onClick={() => void logout()} title="Wyloguj">
          ⏻
        </button>
      </header>

      <main className="content">
        <Outlet />
      </main>

      <nav className="bottomnav" aria-label="Nawigacja główna">
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) => `bottomnav__item ${isActive ? "bottomnav__item--active" : ""}`}
          >
            <span className="bottomnav__icon" aria-hidden="true">
              {item.icon}
            </span>
            <span className="bottomnav__label">{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
